import { css } from '@emotion/css'
import { fontWeight, fontSize, spacing } from '../../../styles'
import { shorthandHelper } from '../../../styles/helpers'
import getThemeColors, { colors } from '../../../themes'

const styles = {
  item: css({
    display: 'flex',
    alignItems: 'flex-start',
    lineHeight: 1.2,
    fontWeight: fontWeight.regular,
    color: colors.jumbo,
    marginLeft: 0,

    '& > * + *': {
      marginLeft: spacing.default,
    },
  }),

  iconWrapper: css({
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  }),

  title: css({
    marginBottom: spacing.extraSmall,
    fontWeight: fontWeight.semiBold,
    marginRight: 'auto',
  }),

  subtitle: css({
    '& + *': {
      marginTop: spacing.default,
    },
  }),

  content: css({
    width: '100%',
  }),

  deleteButton: css({
    margin: shorthandHelper(['auto', 0, 'auto', spacing.small]),
  }),

  editButton: css({
    margin: shorthandHelper(['auto', 0]),
  }),

  titleWrapper: css({
    display: 'flex',
    alignItems: 'center',
  }),
}

export default styles

export const itemSize = size => {
  switch (size) {
    case 'extraSmall':
    case 'small':
      return css({
        fontSize: fontSize.small,
      })

    case 'medium':
    case 'large':
      return css({
        fontSize: fontSize.default,
      })

    default:
      return css({
        fontSize: fontSize.small,
      })
  }
}

export const iconWrapperTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    backgroundColor: themed.light,
  })
}

export const iconWrapperSize = size => {
  switch (size) {
    case 'extraSmall':
      return css({
        width: 14,
        height: 14,
      })

    case 'small':
      return css({
        width: 16,
        height: 16,
      })

    case 'medium':
      return css({
        width: 20,
        height: 20,
      })

    case 'large':
      return css({
        width: 24,
        height: 24,
      })

    default:
      return css({
        width: 18,
        height: 18,
      })
  }
}

export const iconColor = theme => {
  const themed = getThemeColors(theme)
  return themed.base
}

export const iconSize = (size, withBackground) => {
  switch (size) {
    case 'extraSmall':
      return withBackground ? 10 : 14

    case 'small':
      return withBackground ? 12 : 16

    case 'medium':
      return withBackground ? 14 : 20

    case 'large':
      return withBackground ? 16 : 24

    default:
      return withBackground ? 12 : 18
  }
}
